import * as yup from 'yup'

const schema = yup.object().shape({
  responsibleId: yup.number().required(),
})

export default schema
